import "../components/error/style.scss"

import { Link } from "gatsby"
import * as React from "react"
import { useTranslation } from "react-i18next"

import Head from "../components/head"
import Layout from "../components/layout"

const linksContainerStyles = {
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  justifyContent: "center",
  marginTop: "20px"
}

const linkStyles = {
  padding: "12px 24px",
  backgroundColor: "var(--cp-accent)",
  color: "var(--cp-accent-contrast)",
  textDecoration: "none",
  borderRadius: "40px",
  fontSize: "16px",
  fontWeight: "500",
  transition: "background-color 0.3s"
}

// markup
const NotFoundPage = () => {
  const { t } = useTranslation(["errors", "meta"])

  return (
    <div className="error-page">
      <Head
        title={t("meta:notFound.title")}
        description={t("meta:notFound.description")}
        keywords={t("meta:notFound.keywords")}
        noindex
      />
      <Layout>
        <main>
          <h1>{t("errors:notFound.heading")}</h1>
          <p>
            {t("errors:notFound.body")}
            <br />
            {t("errors:notFound.hint")}
          </p>
          <div style={linksContainerStyles}>
            <Link to="/" style={linkStyles}>
              {t("errors:notFound.goHome")}
            </Link>
            <Link to="/events" style={linkStyles}>
              {t("errors:notFound.browseEvents")}
            </Link>
          </div>
        </main>
      </Layout>
    </div>
  )
}

export default NotFoundPage
